import React from "react";
import styles from "./textComponents.module.css";

export function Heading({ children, color = "#000", size = '2rem' }) {
  return (
    <h2 className={styles.heading} style={{ color, fontSize: size }}>
      {children}
    </h2>
  );
}

export function MainHeading({ children, color = "#000", size = '2.5rem' }) {
  return (
    <h1 className={styles.heading_2} style={{ color, fontSize: size }}>
      {children}
    </h1>
  );
}

export function Paragraph({ children, color = "#000" }) {
  return <p className={styles.paragraph} style={{ color }}>{children}</p>;
}
